import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Icon } from '@iconify/react';
import moment from 'moment';
import { Done } from '@mui/icons-material';
import StepperVertical from '../../components/Stepper/StepperVertical';
import { inspectionService, lifeCycleSnapshot } from '../../services/vehicles';
import useMetaData from '../../hooks/useMetaData';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import { contentType, handleContent } from '../Reservation';

const Inspection = () => {
  // use hooks
  const { reservationId } = useParams<{ reservationId: string }>();
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.LifeCycleSnapShot);

  // local sates
  const [inspectionData, setInspectionData] = useState<any>(null);
  const [inspect, setInspect] = useState<any>(null);

  // constants
  const stepsVertical = inspectionData?.stageInformation
    ?.sort((a: any, b: any) => parseFloat(b?.sequence) - parseFloat(a?.sequence))
    ?.filter(
      (fil: { ruleResult: { isCompleted: boolean }; subStage: string; showSubStage: boolean }) => fil?.showSubStage
    )
    ?.map((item: any) => {
      return {
        id: '1',
        label: (
          <Typography variant="body2" fontWeight={500} fontSize={16} color="#1F1F1F">
            {metaData?.fields?.[item?.subStage]?.caption}
          </Typography>
        ),
        content: <>{handleContent(item?.ruleResult, metaData?.fields?.[item?.subStage])}</>,
        isCompleted: item?.ruleResult?.isCompleted,
      };
    });

  // fetching record
  const fetchInspectionData = useCallback(async () => {
    try {
      const inspResp = await inspectionService({ method: 'GET', url: `${reservationId}/config` });
      setInspect(inspResp?.data?.data);
      const resp = await lifeCycleSnapshot({
        method: 'POST',
        data: {
          reservationId,
          stages: ['Inspection'],
          langCode: 'en-us',
        },
      });
      setInspectionData(resp?.data?.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }, [reservationId]);

  // lifecycle hooks
  useEffect(() => {
    fetchInspectionData();
  }, [fetchInspectionData]);

  if (!inspectionData && !metaData)
    return (
      <Box sx={{ position: 'relative', minHeight: '250px' }}>
        <CircularProgress
          color="inherit"
          size={18}
          sx={{ position: 'absolute', left: '0', right: '0', top: '50%', margin: '0 auto' }}
        />
      </Box>
    );
  return (
    <Box>
      <Typography fontSize={20} mb={1.2} fontWeight={500} lineHeight="24px">
        Inspection Lifecycle
      </Typography>
      <Grid item xs={12} mb={1}>
        <Divider sx={{ borderColor: '#e3e3e3' }} />
      </Grid>
      {/* <Box
        sx={{
          border: '1px solid #E04732',
          borderRadius: '4px',
          padding: '5px 8px',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          width: 'calc(100% - 50px)',
        }}
        my={1.5}
      >
        <Icon icon="ri:information-line" fontSize={14} color="#E04732" />
        <Typography fontSize={12} fontWeight={400} color="#E04732" marginLeft={1.2} flexGrow={1}>
          Vehicle has 2 warnings
        </Typography>
        <Typography fontSize={12} fontWeight={400} color="#456BD9">
          View more
        </Typography>
        <List sx={{ flexBasis: '100%', margin: '3px 0 0 20px', padding: '0' }}>
          <ListItem sx={{ padding: '0 0 0 15px' }}>
            <Typography fontSize={12} fontWeight={400}>
              PDC 15CHMSL as of Sep 10, 2022
            </Typography>
          </ListItem>
          <ListItem sx={{ padding: '0 0 0 15px' }}>
            <Typography fontSize={12} fontWeight={400}>
              Software update as of Sep 10, 2022
            </Typography>
          </ListItem>
        </List>
      </Box> */}
      <StepperVertical steps={stepsVertical} activeStep={stepsVertical?.length ?? 10} />
      {/* <Box marginTop={4} marginBottom={2}>
        <Typography variant="h4" fontSize={14} fontWeight={500}>
          Inspection Details
        </Typography>
        <Grid item xs={12} mb={1}>
          <Divider sx={{ borderBottom: '1px dashed #e3e3e3', paddingBottom: '12px' }} />
        </Grid>
        <Typography fontSize={14} fontWeight={500}>
          Holds
        </Typography>
        <TableContainer component={Paper} sx={{ borderRadius: '0', boxShadow: 'none' }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ pt: '8px', pb: '8px', pl: '15px', pr: '15px', background: '#F9F9F9' }}>
                  <Typography fontSize={12} fontWeight={500} color="#555354">
                    Start Date
                  </Typography>
                </TableCell>
                <TableCell sx={{ pt: '8px', pb: '8px', pl: '15px', pr: '15px', background: '#F9F9F9' }}>
                  <Typography fontSize={12} fontWeight={500} color="#555354">
                    Notes
                  </Typography>
                </TableCell>
                <TableCell sx={{ pt: '8px', pb: '8px', pl: '15px', pr: '15px', background: '#F9F9F9' }}>
                  <Typography fontSize={12} fontWeight={500} color="#555354">
                    Status
                  </Typography>
                </TableCell>
                <TableCell sx={{ pt: '8px', pb: '8px', pl: '15px', pr: '15px', background: '#F9F9F9' }}>
                  <Typography fontSize={12} fontWeight={500} color="#555354">
                    End Date
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Sep 12, 2022</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Minor scratch at the bonnet</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography
                    color="#288E49"
                    fontSize={12}
                    fontWeight={500}
                    sx={{
                      padding: '2px 5px',
                      lineHeight: 1,
                      border: '1px solid #288E49',
                      textAlign: 'center',
                      display: 'inline-block',
                      borderRadius: '2px',
                    }}
                  >
                    Done
                  </Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Sep 12, 2022</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Sep 9, 2022</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Fan whistling</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography
                    color="#E04732"
                    fontSize={12}
                    fontWeight={500}
                    sx={{
                      padding: '2px 5px',
                      lineHeight: 1,
                      border: '1px solid #E04732',
                      textAlign: 'center',
                      display: 'inline-block',
                      borderRadius: '2px',
                    }}
                  >
                    In Progress
                  </Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>-</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Sep 8, 2022</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Headlights not throwing proper lumins</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography
                    color="#E04732"
                    fontSize={12}
                    fontWeight={500}
                    sx={{
                      padding: '2px 5px',
                      lineHeight: 1,
                      border: '1px solid #E04732',
                      textAlign: 'center',
                      display: 'inline-block',
                      borderRadius: '2px',
                    }}
                  >
                    In Progress
                  </Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>-</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box> */}
      {/* <Box marginTop={2} marginBottom={2}>
        <Typography fontSize={14} fontWeight={500}>
          Work Orders
        </Typography>
        <TableContainer component={Paper} sx={{ borderRadius: '0', boxShadow: 'none' }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ pt: '8px', pb: '8px', pl: '15px', pr: '15px', background: '#F9F9F9' }}>
                  <Typography fontSize={12} fontWeight={500} color="#555354">
                    Work Orders #
                  </Typography>
                </TableCell>
                <TableCell sx={{ pt: '8px', pb: '8px', pl: '15px', pr: '15px', background: '#F9F9F9' }}>
                  <Typography fontSize={12} fontWeight={500} color="#555354">
                    Start Date
                  </Typography>
                </TableCell>
                <TableCell sx={{ pt: '8px', pb: '8px', pl: '15px', pr: '15px', background: '#F9F9F9' }}>
                  <Typography fontSize={12} fontWeight={500} color="#555354">
                    Notes
                  </Typography>
                </TableCell>
                <TableCell sx={{ pt: '8px', pb: '8px', pl: '15px', pr: '15px', background: '#F9F9F9' }}>
                  <Typography fontSize={12} fontWeight={500} color="#555354">
                    Status
                  </Typography>
                </TableCell>
                <TableCell sx={{ pt: '8px', pb: '8px', pl: '15px', pr: '15px', background: '#F9F9F9' }}>
                  <Typography fontSize={12} fontWeight={500} color="#555354">
                    End Date
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>WO1229588</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Sep 12, 2022</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Headlight change request</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography
                    color="#E04732"
                    fontSize={12}
                    fontWeight={500}
                    sx={{
                      padding: '2px 5px',
                      lineHeight: 1,
                      border: '1px solid #E04732',
                      textAlign: 'center',
                      display: 'inline-block',
                      borderRadius: '2px',
                    }}
                  >
                    In Progress
                  </Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Sep 12, 2022</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>WO1229588</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Sep 9, 2022</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>Vehicle Insepction</Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography
                    color="#288E49"
                    fontSize={12}
                    fontWeight={500}
                    sx={{
                      padding: '2px 5px',
                      lineHeight: 1,
                      border: '1px solid #288E49',
                      textAlign: 'center',
                      display: 'inline-block',
                      borderRadius: '2px',
                    }}
                  >
                    Done
                  </Typography>
                </TableCell>
                <TableCell component="td" scope="row" sx={{ pt: '9px', pb: '9px', pl: '15px' }}>
                  <Typography fontSize={12}>-</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box> */}
    </Box>
  );
};

export default Inspection;
